import React from 'react';
import styled from 'styled-components';
import { colorMediumGray } from '../../config/theme';

const InputContainer = styled.label<{checked?: boolean}>`
    position: relative;
    padding-left: 2.5rem;
    display: block;
    cursor: pointer;

    &.gender {
        margin-right: 20px;
        display: inline-block;
        @media screen and (min-width: 768px) {
            margin-right: 50px;
        }
    }

    &:before {
        position: absolute;
        display: inline-block;
        left: 0;
        width: 25px;
        height: 25px;
        border: solid 1px ${colorMediumGray};
        border-radius: 50%;
        text-align: center;

        ${(props) => props.checked ? `
            content: '●';
            color: #AEC90A;
            font-size: 25px;
            line-height: 23px;
            @media screen and (min-width: 768px) {
                font-size: 41px;
                line-height: 18px;
            }
        ` : `
            content: '';
        `}
    }

    input[type=radio] {
        display: none;
    }
`;

type RadioInputProps = {
    children: React.ReactNode;
    required?: boolean;
    class?: string;
    checked: boolean;
    onChange: (value: string) => void;
    value: string;
    name: string;
}

export function RadioInput(props: RadioInputProps) {
    return <InputContainer checked={props.checked} className={props.class}>
        <input
            type='radio'
            value={props.value}
            name={props.name}
            required={props.required}
            checked={!!props.checked}
            onChange={(e) => props.onChange(e.target.value)}
        />
        {props.children}
    </InputContainer>
}
